import { useMutation, useQueryClient } from '@tanstack/react-query';
import { gqlFetcher, type MutationOptions } from '../fetcher';
import { CreateIncidentCategory } from '../mutations/createIncidentCategory.mutation';
import type {
  CreateIncidentCategoryMutation,
  CreateIncidentCategoryMutationVariables,
} from '../types';

export const useCreateIncidentCategoryMutation = (
  options?: MutationOptions<
    CreateIncidentCategoryMutation,
    CreateIncidentCategoryMutationVariables
  >,
) => {
  const queryClient = useQueryClient();

  return useMutation(gqlFetcher(CreateIncidentCategory), {
    ...options,
    onSettled: async (resp, error, variables, ctx) => {
      await options?.onSettled?.(resp, error, variables, ctx);

      queryClient.invalidateQueries({
        predicate: (query) => query.queryKey.includes('incidentCategories'),
      });
    },
  });
};
